'helper'.trashAll('Inventory')
'helper'.trashAll('Cluster')
'helper'.trashAll('Location')
'helper'.trashAll('Configuration')
'helper'.simulateBrowserRefresh()
'Locations'.click()                                                 // Back button and confirm dialog
'mainTable.0.Name'.shouldEqual('General')
'mainTable.0.Trash'.click()
'mainTable.0.Really Trash?'.click()
'messageDialogText'.shouldEqual('The "General" location cannot be trashed', 'doc')
'messageDialogOK'.click('doc')
'mainTable.0.Name'.shouldEqual('General')
'mainTable'.shouldHaveCount(1)
'mainTable.0.Edit'.click()
'Name'.shouldBeReadOnly()
'Parent Location'.shouldBeReadOnly()
'Back'.click()
'Add'.click()
'Add Location'.shouldBeCurrentPage()
'Back'.click()
'confirmLeave'.shouldntExist('doc')
'Locations'.shouldBeCurrentPage()
'Add'.click()
'Name'.enter('Warehouse 10')
'browser'.back()
'confirmLeave'.shouldExist('doc')
'Yes - Cancel my changes'.click('doc')
'confirmLeave'.shouldntExist('doc')
'Locations'.shouldBeCurrentPage()
'mainTable'.shouldHaveCount(1)
'Add'.click()
'Name'.enter('Warehouse 10')
'browser'.back()
'confirmLeave'.shouldExist('doc')
'No - Stay on this page'.click('doc')
'confirmLeave'.shouldntExist('doc')
'Add Location'.shouldBeCurrentPage()
'Save'.click()
'Edit Location'.shouldBeCurrentPage()
'browser'.back()
'Add Location'.shouldBeCurrentPage()
'browser'.back()
'Locations'.shouldBeCurrentPage()
'Back'.click()
'Back'.click()
'Back'.click()
'Home'.shouldBeCurrentPage()
'Locations'.click()                                                  // Menu buttons confirm dialog
'mainTable'.shouldHaveCount(2)
'mainTable./General/.Inventory'.click()
  'Location Inventory'.shouldBeCurrentPage()
  'Location'.shouldEqual('General')
  'Back'.click()
'mainTable./Warehouse 10/.Inventory'.click()
  'Location Inventory'.shouldBeCurrentPage()
  'Location'.shouldEqual('Warehouse 10')
  'Back'.click()
'Locations'.click()
'mainTable'.forEach('name !== "General"', {lastToFirst: true})
  'Trash'.click()
  'Really Trash?'.click()
  'mainTable'.endForEach()
'mainTable'.shouldHaveCount(1)
'Add'.click()
'Add Location'.shouldBeCurrentPage()
'stocktend_purchaseOrders'.click()
'confirmLeave'.shouldntExist('doc')
'Purchase Orders'.shouldBeCurrentPage()
'Locations'.click()
'Add'.click()
'Name'.enter('Warehouse 10')
'stocktend_purchaseOrders'.click()
'confirmLeave'.shouldExist('doc')
'Yes - Cancel my changes'.click('doc')
'confirmLeave'.shouldntExist('doc')
'Purchase Orders'.shouldBeCurrentPage()
'Locations'.click()
'mainTable'.shouldHaveCount(1)
'Add'.click()
'Name'.enter('Warehouse 10')
'stocktend_purchaseOrders'.click()
'confirmLeave'.shouldExist('doc')
'No - Stay on this page'.click('doc')
'confirmLeave'.shouldntExist('doc')
'Add Location'.shouldBeCurrentPage()
'Save'.click()
'Edit Location'.shouldBeCurrentPage()                                // Maintenance / Location Maintenance
'Locations'.click()
'mainTable'.shouldHaveCount(2)
'mainTable.1.Edit'.click()
'Name'.shouldEqual('Warehouse 10')
'Name'.enter("Warehouse '11'")
'Save'.click()
'Locations'.click()
'mainTable.1.Name'.shouldEqual("Warehouse '11'")
'Add'.click()
'Name'.enter('Warehouse 20')
'Parent Location'.shouldEqual('General')
'Parent Location'.enter('')
'OK'.click()
'stFormRejection'.shouldContain('You must enter a parent location')
'Parent Location'.chooseOption("Warehouse '11'")
'OK'.click()
'Locations'.shouldBeCurrentPage()
'mainTable.2.Edit'.click()
'Parent Location'.shouldEqual("Warehouse '11'")
'Add another'.click()
'Name'.enter('Warehouse "30"')
'Save'.click()
'Edit Location'.shouldBeCurrentPage()
'Add another'.click()
'Name'.shouldEqual('')
'Name'.shouldntHaveError()
'Save'.click()
'Name'.shouldHaveError("You must enter a Location Name")
'Name'.enter('Warehouse "30"')
'Name'.shouldHaveError("location already exists")
'Save'.click()
'stFormRejection'.shouldContain("This Location already exists")
'Name'.enter('Warehouse 25')
'Parent Location'.clickDropdown()
'Parent Location'.shouldHaveNOptions(5) // counting blank
'Parent Location'.shouldHaveOption('Warehouse 20')
'Parent Location'.chooseOption('Warehouse 20')
'Parent Location'.shouldEqual('Warehouse 20')
'Name'.shouldntHaveError()
'Save'.shouldntHaveError()
'Save'.click()
'Save'.shouldntHaveError()
'Locations'.click()
'mainTable'.shouldHaveCount(5)
'mainTable.1.Name'.shouldEqual('Warehouse "30"')
'mainTable.2.Name'.shouldEqual("Warehouse '11'")
'mainTable.3.Name'.shouldEqual('Warehouse 20')
'mainTable.4.Name'.shouldEqual('Warehouse 25')
'mainTable.4.Edit'.click()
'Parent Location'.shouldEqual('Warehouse 20')
'Locations'.click()
'mainTable.3.Edit'.click()
'Name'.shouldEqual('Warehouse 20')
'Parent Location'.clickDropdown()
'Parent Location'.shouldHaveNOptions(5)
'Back'.click()
'confirmLeave'.shouldntExist('doc')
'mainTable.3.Edit'.click()
'Name'.enter('Warehouse 21')
'Back'.click()
'confirmLeave'.shouldExist('doc')
'No - Stay on this page'.click('doc')
'confirmLeave'.shouldntExist('doc')
'Save'.click()
'Locations'.click()
'mainTable.3.Name'.shouldEqual('Warehouse 21')
'mainTable.3.Name'.shouldEqual('Warehouse 21')
'mainTable.3.Trash'.click()
'mainTable.3.Really Trash?'.click()
'mainTable'.shouldHaveCount(4)
'mainTable.3.Name'.shouldEqual('Warehouse 25')
'Back'.click()
